import { HStack, IconButton, Input, Text } from "@chakra-ui/react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { useSearchParams } from "react-router-dom";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setSearchParams] = useSearchParams();

  const handleInputChange = (value: string) => {
    const page = parseInt(value, 10);
    if (!isNaN(page) && page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const handlePreviousPage = () => {
    onPageChange(currentPage - 1);
    setSearchParams({ page: String(currentPage - 1) });
  };

  const handleNextPage = () => {
    onPageChange(currentPage + 1);
    setSearchParams({ page: String(currentPage + 1) });
  };

  return (
    <HStack spacing={2} justify="center" mt={4}>
      <IconButton
        aria-label="Previous page"
        icon={<MdChevronLeft />}
        onClick={handlePreviousPage}
        isDisabled={currentPage <= 1}
      />
      <Input
        value={currentPage}
        onChange={(e) => handleInputChange(e.target.value)}
        width="60px"
        textAlign="center"
      />
      <Text>of {totalPages}</Text>
      <IconButton
        aria-label="Next page"
        icon={<MdChevronRight />}
        onClick={handleNextPage}
        isDisabled={currentPage >= totalPages}
      />
    </HStack>
  );
}
